<template>
    <section id="contacts" class="py-20 lg:py-28 bg-secondary">
        <div class="container mx-auto px-4">
            <div class="text-center mb-12">
                <h2 class="text-3xl md:text-4xl font-bold text-foreground mb-4">
                    {{ content.title_before }}
                    <span v-if="content.title_accent" class="text-gradient-blue">{{ content.title_accent }}</span>
                    {{ content.title_after }}
                </h2>
            </div>

            <div class="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
                <div class="bg-card rounded-2xl p-8 shadow-sm border border-border">
                    <h3 v-if="content.requisites_title" class="text-xl font-bold text-foreground mb-6">
                        {{ content.requisites_title }}
                    </h3>
                    <div class="space-y-5 text-sm text-foreground/80">
                        <div v-for="(group, i) in requisites" :key="i">
                            <p v-if="group.heading" class="font-semibold text-foreground">{{ group.heading }}</p>
                            <p v-for="(line, l) in group.lines || []" :key="l">{{ line }}</p>
                        </div>
                        <div v-if="content.email">
                            <p class="font-semibold text-foreground">E-mail</p>
                            <a :href="`mailto:${content.email}`" class="text-accent hover:underline font-medium">
                                {{ content.email }}
                            </a>
                        </div>
                    </div>
                </div>

                <div class="bg-card rounded-2xl p-8 shadow-sm border border-border">
                    <h3 v-if="content.form_title" class="text-xl font-bold text-foreground mb-6">
                        {{ content.form_title }}
                    </h3>
                    <form v-if="!sent" class="space-y-4" @submit.prevent="submit">
                        <input
                            v-model="form.company"
                            type="text"
                            placeholder="Компания"
                            class="w-full px-4 py-2.5 rounded-md border border-border bg-background text-foreground"
                        />
                        <input
                            v-model="form.name"
                            type="text"
                            placeholder="Имя"
                            class="w-full px-4 py-2.5 rounded-md border border-border bg-background text-foreground"
                        />
                        <input
                            v-model="form.phone"
                            type="tel"
                            placeholder="Телефон"
                            class="w-full px-4 py-2.5 rounded-md border border-border bg-background text-foreground"
                        />
                        <input
                            v-model="form.email"
                            type="email"
                            placeholder="E-mail"
                            class="w-full px-4 py-2.5 rounded-md border border-border bg-background text-foreground"
                        />
                        <!-- honeypot: скрытое поле против ботов, люди его не видят и не заполняют -->
                        <input
                            v-model="form.website"
                            type="text"
                            name="website"
                            class="hidden"
                            tabindex="-1"
                            autocomplete="off"
                            aria-hidden="true"
                        />
                        <ConsentCheckbox v-if="landingConsent.lead" :text="landingConsent.lead" />
                        <button
                            type="submit"
                            :disabled="sending"
                            class="w-full px-6 py-3 rounded-md font-semibold bg-accent text-accent-foreground hover:bg-accent/90 transition-colors disabled:opacity-60"
                        >
                            {{ sending ? "Отправка..." : content.form_submit_label || "Отправить" }}
                        </button>
                        <p v-if="error" class="text-sm text-destructive">{{ error }}</p>
                    </form>
                    <p v-else class="text-accent font-medium py-6">
                        {{ content.form_success || "Заявка отправлена!" }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import ConsentCheckbox from "./ConsentCheckbox.vue";

export default {
    name: "CtaBlock",
    components: { ConsentCheckbox },
    inject: {
        landingConsent: { default: () => ({}) },
    },
    props: { content: { type: Object, default: () => ({}) } },
    data() {
        return {
            sent: false,
            sending: false,
            error: "",
            form: { company: "", name: "", phone: "", email: "", website: "" },
        };
    },
    computed: {
        requisites() {
            return this.content.requisites || [];
        },
    },
    methods: {
        async submit() {
            if (this.sending) {
                return;
            }
            if (!this.form.phone.trim() && !this.form.email.trim()) {
                this.error = "Укажите телефон или e-mail для связи.";

                return;
            }

            this.sending = true;
            this.error = "";
            try {
                const response = await fetch("/api/landing/lead", {
                    method: "POST",
                    credentials: "same-origin",
                    headers: { "Content-Type": "application/json", Accept: "application/json" },
                    body: JSON.stringify(this.form),
                });
                if (!response.ok) {
                    throw new Error("Не удалось отправить заявку. Попробуйте ещё раз.");
                }

                this.sent = true;
                this.trackGoal();
            } catch (error) {
                this.error = error.message;
            } finally {
                this.sending = false;
            }
        },
        trackGoal() {
            const metrikaId = window._landing_metrika_id;
            if (metrikaId && typeof window.ym === "function") {
                window.ym(metrikaId, "reachGoal", "landing_lead");
            }
        },
    },
};
</script>
